import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNext = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 12,
	viewBox: "0 0 11 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10 12C9.44772 12 9 11.5523 9 11L9 1C9 0.4477 9.44772 -1.35705e-07 10 -8.74228e-08C10.5523 -3.91409e-08 11 0.447701 11 1L11 11C11 11.5523 10.5523 12 10 12ZM7.92131 5.5915C7.96792 5.6244 8.00856 5.6651 8.04146 5.7117C8.2007 5.9373 8.14691 6.2492 7.92131 6.4085L0.7883 11.4435C0.704 11.5031 0.6033 11.535 0.5 11.535C0.2239 11.535 6.02186e-08 11.3112 8.43595e-08 11.035L9.6471e-07 0.964999C9.73741e-07 0.861699 0.0320006 0.760999 0.0915003 0.676599C0.2508 0.450998 0.5627 0.397199 0.788301 0.556499L7.92131 5.5915Z"
	})
});
export default SvgNext;
